import moment from "moment";

function formatMomentDate(dStr, inputFormat, outputFormat, defaultValue) {
    const mDate = moment(dStr, inputFormat);
    if (mDate.isValid() && mDate.format(inputFormat) === dStr)
        return mDate.format(outputFormat);
    else
        return defaultValue === undefined ? null : defaultValue;
}


export default {
    methods : {
        dt_for_user(dStr, inputFormat) {
            inputFormat = inputFormat || this.dt_default_store_format;
            return formatMomentDate(dStr,inputFormat,this.dt_default_view_format)
        },
        dt_from_user(dStr, inputFormat) {
            inputFormat = inputFormat || this.dt_default_view_format;
            return formatMomentDate(dStr,inputFormat,this.dt_default_store_format)
        },
        dt_obj_from_user(dStr,inputFormat,defaultValue){
            inputFormat = inputFormat || this.dt_default_view_format;
            const mDate = moment(dStr, inputFormat);
            if (mDate.isValid() && mDate.format(inputFormat) === dStr)
                return mDate;
            else
                return defaultValue === undefined ? null : defaultValue;
        },
    },
    computed: {
        dt_default_view_format() {
            return this.$store.state.config.dateFormat;
        },
        dt_default_store_format() {
            return 'MM/DD/YYYY';
        },
    }
};
